<template lang="html">
	<common-transition-slide :active="!isLoading">
		<div class="campaign-type-filter" @keydown.esc="clearFilters">
			<div class="campaign-type-filter__nav omapi-card__flex">
				<div v-if="!isLoading" class="campaign-type-filter__filters">
					<div
						class="campaign-type-filter__filter campaign-type-filter__filter-featured"
						:class="{ selected: 'featured' === sort }"
						@click="setSort('featured')"
					>
						<span>Featured</span>
					</div>
					<div
						class="campaign-type-filter__filter campaign-type-filter__filter-latest"
						:class="{ selected: 'recent' === sort }"
						@click="setSort('recent')"
					>
						<span>Latest</span>
					</div>
					<div class="campaign-type-filter__filter campaign-type-filter__filter-device">
						<span>{{ selectedDeviceName }}</span>
						<div class="campaign-type-filter__filter-options">
							<div
								class="campaign-type-filter__filter-device-desktop"
								:class="{ selected: isDeviceSelected('desktop') }"
								@click="setDevice('desktop')"
							>
								<span class="device-icons">
									<img
										class="device-icons-desktop"
										src="../../assets/images/icons/device-desktop.svg"
										alt="Desktop Icon"
									/>
									<img
										class="device-icons-tablet"
										src="../../assets/images/icons/device-tablet.svg"
										alt="Tablet Icon"
									/>
								</span>

								All Devices
								<small>(Responsive)</small>
							</div>
							<div
								class="campaign-type-filter__filter-device-mobile"
								:class="{ selected: isDeviceSelected('mobile') }"
								@click="setDevice('mobile')"
							>
								<span class="device-icons">
									<img
										class="device-icons-mobile"
										src="../../assets/images/icons/device-mobile.svg"
										alt="Mobile Icon"
									/>
								</span>

								Mobile Specific
								<small>(Optimized)</small>
							</div>
						</div>
					</div>
					<div
						class="campaign-type-filter__filter campaign-type-filter__filter-category"
						:class="{ active: showCategories }"
						@click="toggleCategories"
					>
						<span>
							<svg-cog />
							<span>Category Filter</span>
						</span>
					</div>
				</div>
				<div v-if="!isLoading" class="campaign-type-filter__search">
					<input
						placeholder="Search Templates..."
						type="text"
						class="omapi-input"
						:value="search"
						@input="updateSearch"
						@keydown.esc="clearSearch"
					/>
					<svg-times v-if="search" class="clear-search" @click="clearSearch" />
				</div>
			</div>
			<common-transition-slide :active="showCategories">
				<div class="campaign-type-filter-device-options">
					<div class="omapi-card__flex filters-top">
						<div class="filters-left omapi-card__flex">
							<div class="campaign-type-filter__filter-categories omapi-radio-group">
								<strong>Categories</strong>
								<div v-if="options.categories">
									<label
										v-for="option in options.categories"
										:key="option.id"
										class="omapi-checkbox"
										@input="setTaxonomyFilter('categories', option)"
									>
										<input
											type="checkbox"
											:value="option.id"
											:checked="filterSet('categories', option)"
										/>
										<span class="omapi-checkbox__input"></span>
										{{ option.name }}
									</label>
								</div>
							</div>
							<div class="campaign-type-filter__filter-goals omapi-radio-group">
								<strong>Goals</strong>
								<div v-if="options.goals">
									<label
										v-for="option in options.goals"
										:key="option.id"
										class="omapi-checkbox"
										@input="setTaxonomyFilter('goals', option)"
									>
										<input
											type="checkbox"
											:value="option.id"
											:checked="filterSet('goals', option)"
										/>
										<span class="omapi-checkbox__input"></span>
										{{ option.name }}
									</label>
								</div>
							</div>
							<div class="campaign-type-filter__filter-tags omapi-radio-group">
								<strong>Tags</strong>
								<div v-if="options.tags">
									<label
										v-for="option in tags"
										:key="option.id"
										class="omapi-checkbox"
										@input="setTaxonomyFilter('tags', option)"
									>
										<input
											type="checkbox"
											:value="option.id"
											:checked="filterSet('tags', option)"
										/>
										<span class="omapi-checkbox__input"></span>
										{{ option.name }}
									</label>
								</div>
							</div>
						</div>
						<div class="filters-right omapi-card__flex">
							<div class="did-you-know">
								<img src="../../assets/images/icons/gamified-icon.svg" />
								<div>
									<strong>Did you know?</strong>
									<p>
										Gamified optins have been known to turn 2-3% conversion rates into conversion
										rates of 30% or more!
									</p>
									<p>
										<core-button
											type="secondary"
											target="_blank"
											rel="noopener"
											:href="
												$urls.upgrade({
													utm_medium: 'DYKTemplates',
													feature: 'coupon-wheel-campaigns',
												})
											"
											>Learn More</core-button
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="filters-bottom">
						<core-button type="secondary" :disabled="!hasFilters" @click="clearFilters"
							>Clear Filters</core-button
						>
					</div>
				</div>
			</common-transition-slide>
		</div>
	</common-transition-slide>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters } = createNamespacedHelpers('templates')

export default {
	data () {
		return {
			showCategories : false,
		}
	},
	computed : {
		...mapState([ 'sort', 'search', 'activeType', 'loading', 'filterOptions' ]),
		...mapGetters([ 'filters' ]),
		options () {
			let options = {}
			this.filterOptions.forEach(o => {
				options[o.slug] = o.values
			})
			return options
		},
		hasFilters () {
			return Object.keys(this.filters).find(f => {
				return 'device' !== f && this.filters[f].length
			}) || this.search
		},
		deviceOption () {
			return this.options.device || []
		},
		isLoading () {
			return this.$store.getters.isLoading('templates')
		},
		tags () {
			return this.options.tags.filter(o => 'Featured' !== o.name)
		},
		selectedDevice () {
			let option = { id: '', name: '' }

			if (this.filters.device) {
				const found = this.deviceOption.filter(o => this.filters.device === o.id)
				if (found[0]) {
					option = found[0]
				}
			}

			return option
		},
		selectedDeviceValue () {
			return this.selectedDevice.id
		},
		selectedDeviceName () {
			let name = 'Device'
			if (this.selectedDevice.name) {
				name += ': ' + this.selectedDevice.name
			}

			return name
		},
	},
	methods : {
		clearSearch () {
			this.$store.commit('templates/setSearch', '')
		},
		updateSearch (e) {
			this.$store.commit('templates/setSearch', e.target.value)
		},
		clearFilters () {
			this.clearSearch()
			this.$store.commit('templates/clearFilters')
		},
		isDeviceSelected (type) {
			return type === this.filters.device
		},
		filterSet (filter, option) {
			return this.filters[filter].includes(option.id)
		},
		setTaxonomyFilter (filter, option) {
			const value = [ ...this.filters[filter] ]
			const index = value.indexOf(option.id)
			if (-1 !== index) {
				value.splice(index, 1)
			} else {
				value.push(option.id)
			}

			this.$store.commit('templates/setFilter', { filter, value: value })
		},
		setDevice (type) {
			this.$store.commit('templates/setFilter', { filter: 'device', value: type || '' })
		},
		setSort (sortBy) {
			this.$store.commit('templates/setSort', sortBy)
			this.showCategories = false
		},
		toggleCategories () {
			this.showCategories = !this.showCategories
		},
	},
};
</script>
<style lang="scss">
@import '../../assets/scss/variables';
@import '../../assets/scss/components/templates-filters';
</style>
